export function GridLines() {
  return (
    <svg
      className="absolute inset-0 w-full h-full pointer-events-none"
      aria-hidden
    >
      <defs>
        <pattern
          id="grid-pat"
          width="72"
          height="72"
          patternUnits="userSpaceOnUse"
        >
          <path
            d="M 72 0 L 0 0 0 72"
            fill="none"
            stroke="white"
            strokeWidth="0.4"
            opacity="0.06"
          />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#grid-pat)" />
    </svg>
  );
}
